import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 20,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  textField: {
    margin: 10,
  },
  table: {
    minWidth: 650,
  },
  tableContainer: {
    marginTop: 50,
  },
}));

export default useStyles;
